import {useDispatch} from "react-redux";
import useMerchantPortalAxios from "../utils/axios";
import {setLoading as setEmployeeAPILoading} from "../features/legalEmployeesSlice";
import {useState} from "react";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";

export const useLegalEmployeesAPIs = () => {
    const [employeeLimits, setEmployeeLimits] = useState([]);
    const [limitsLoading, setLimitsLoading] = useState(false);

    const MerchantPortalClient = useMerchantPortalAxios();
    const dispatch = useDispatch();

    async function DeleteLegalEntityEmployee(payload) {
        dispatch(setEmployeeAPILoading("pending"));
        const res = await MerchantPortalClient.post(`/v1/LegalEmployee/DeleteLegalEntityEmployee`, payload);
        dispatch(setEmployeeAPILoading("idle"));
        return res.data.Payload;
    }


    async function EditLegalEntityEmployee(
        payload
    ) {
        dispatch(setEmployeeAPILoading("pending"));
        const res = await MerchantPortalClient.post(`/v1/LegalEmployee/EditLegalEntityEmployee`, payload);
        dispatch(setEmployeeAPILoading("idle"));

        return res.data.Payload;
    }

    const ManageLegalEmployeesStatus = async (payload) => {
        const res = await MerchantPortalClient.post(`/v1/LegalEmployee/ManageLegalEntityEmployeeStatus`, payload);
        return res.data.Payload;
    };

    const AddLegalEntityEmployee = async (payload) => {
        const res = await MerchantPortalClient.post(`/v1/LegalEmployee/AddLegalEntityEmployee`, payload);
        return res.data.Payload;
    };

    const GetEmployeeLimitation = async () => {
        setLimitsLoading(true);
        const req = new BaseRequest(
            sessionStorage.getItem("SessionID")
        );
        const res = await MerchantPortalClient.post(`/v1/LegalEmployee/GetEmployeeLimitation`,
            req
        ).then((res) => {
            setEmployeeLimits(res.data.Payload?.EmployeeRoleLimits);
            setLimitsLoading(false);
        });
    }

    const EditEmployeeLimitation = async (payload) => {
        const res = await MerchantPortalClient.post(`/v1/LegalEmployee/EditEmployeeLimitation`, payload);
        return res.data.Payload;
    }


    return {
        ManageLegalEmployeesStatus,
        EditLegalEntityEmployee,
        DeleteLegalEntityEmployee,
        AddLegalEntityEmployee,
        GetEmployeeLimitation,
        EditEmployeeLimitation,
        employeeLimits,
        limitsLoading
    };

}